import kafedraProtocols from "../data/kafedraProtocols.json";

export { kafedraProtocols };

export function normalizeKafedraName(str) {
  if (!str) return "";
  return String(str)
    .toLowerCase()
    .replace(/[ʻ‘’`'\u02BB\u02BC\u2018\u2019]/g, "'")
    .replace(/bisnes/g, "biznes")
    .replace(/texnologiyalari/g, "texnologiyasi")
    .replace(/logistika\b/g, "logistikasi")
    .replace(/\s+/g, " ")
    .trim();
}

export function findKafedraProtocol(kafedraName) {
  if (!kafedraName) return null;
  const target = normalizeKafedraName(kafedraName);
  if (!target) return null;

  return kafedraProtocols.find((item) => {
    const main = normalizeKafedraName(item.kafedra);
    if (target === main || target.includes(main) || main.includes(target)) {
      return true;
    }
    if (item.aliases && item.aliases.length > 0) {
      return item.aliases.some((alias) => {
        const a = normalizeKafedraName(alias);
        return target === a || target.includes(a) || a.includes(target);
      });
    }
    return false;
  }) || null;
}

export function getKafedraDecisionCoverHtml(kafedraName) {
  const protocol = findKafedraProtocol(kafedraName);
  if (!protocol) {
    return `SHIR kafedraning 2026-yil "___"-________ gi<br/>"___"-sonli yig'ilishida muhokama qilingan va<br/>"___"-sonli bayonnomasi bilan tasdiqlangan.`;
  }

  // Formatting according to the official table:
  // SHIR kafedraning 2026-yil "${day}"-${month}dagi
  // "${meetingNumber}"-sonli yig'ilishida muhokama qilingan va
  // "${protocolNumber}"-sonli bayonnomasi bilan tasdiqlangan.
  return `SHIR kafedraning 2026-yil "${protocol.day}"-${protocol.month}dagi<br/>"${protocol.meetingNumber}"-sonli yig'ilishida muhokama qilingan va<br/>"${protocol.protocolNumber}"-sonli bayonnomasi bilan tasdiqlangan.`;
}

export function getKafedraDecisionText(kafedraName) {
  const protocol = findKafedraProtocol(kafedraName);
  if (!protocol) {
    return "";
  }
  return `SHIR kafedraning 2026-yil "${protocol.day}"-${protocol.month}dagi "${protocol.meetingNumber}"-sonli yig'ilishida muhokama qilingan va "${protocol.protocolNumber}"-sonli bayonnomasi bilan tasdiqlangan.`;
}

export default {
  kafedraProtocols,
  normalizeKafedraName,
  findKafedraProtocol,
  getKafedraDecisionCoverHtml,
  getKafedraDecisionText
};
